import { createApp } from 'vue';
import App from './App.vue';
import router from './router/router'; // 确保这里的路径指向你的路由配置文件
import './assets/icons/iconfont.css'

createApp(App)
  .use(router)
  .mount('#app');
